import React from "react";
import styles from "./FirstPersonData.scss";
import cx from "../../utils/cx";
import TextField from "../MaterialUi/TextField";
import  { ILeadData } from "../../utils/LeadSmartApi";
import Tooltip from "../Tooltip";
import NumberField from "../MaterialUi/NumberField";
import { IFinancialCheckData, INextStepData } from "./FinancialCheckPage";
import Icon from "../MaterialUi/Icon";
import Responsive from "../../utils/Responsive";
import useUser from "../../stores/useUser";
import Button from "../MaterialUi/Button";
// import Select from "../MaterialUi/Select";
import { typeOfEmploymentList } from "../RegisterInvitedUser/UserDetailsOptions";
// import Select from "@mui/material/Select";
import Select from "../MaterialUi/Select";
import MenuItem from "@mui/material/MenuItem";
import { IBaufiImplecoLeadPageProps, IPersonFields } from "./BaufiImplecoLeadPage";
import { inputPatterns } from "../../utils/inputPatterns";

export interface IFirstPersonDataProps {
  className?: string;
  nextStep: () => void;
  setData: (data?: INextStepData) => void;
  data: IFinancialCheckData;
  prevStep?: (data?: INextStepData) => void;
  variant?: IBaufiImplecoLeadPageProps['variant'];
}

// Attributes that are not needed in leadSmartApi


const subtractDate = (date: Date, years: number, months: number, days: number): Date => {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() - years);
    newDate.setMonth(newDate.getMonth() - months);
    newDate.setDate(newDate.getDate() - days);
    return newDate;
} 




const FirstPersonData: React.FC<IFirstPersonDataProps> = ({ nextStep, data, prevStep, setData, className = '' }) => {

    const [fields, setFields] = React.useState<IPersonFields>(data.firstPerson as IPersonFields || {} as IPersonFields);
    // const [termsData, setTermsData] = React.useState(data.termsData || {} as IFinancialCheckData['termsData']);
    const [isLoading, setIsLoading] = React.useState(false);
    const [user] = useUser();

    const handleChange = (ev) => {
        const name = ev.target.name as keyof IPersonFields;
        const value = ev.target.value;
        setFields({
            ...fields,
            [name]: value
        });
    }

    const handleNumberChange = (name, value) => {
        setFields({
            ...fields,
            [name]: value
        });
        if (name === "monthlyNetIncomeInEuro") {
            setData({ leadResponse: undefined })
        }
    };

    const handleDateChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const name = ev.target.name as keyof ILeadData['firstPerson'];
        const value = ev.target.value;
        setFields({
            ...fields,
            [name]: value
        });
    };

    // const handleTermsChange = (ev) => {
    //     const name = ev.target.name as keyof ILeadData['firstPerson'];
    //     const value = ev.target.checked;
    //     setTermsData({
    //         ...termsData,
    //         [name]: value
    //     });
    // }

    const handleSubmit = (ev) => {
        ev.preventDefault();
        setData({ firstPerson: fields });

        // nextStep();

        //         if (data?.loanData && data?.campaign) {
        //     // setData({ loanData: fields });
        // } else {
        //     setIsLoading(true);
        //     LeadSmartApi.leadPreflight(postalCode).then((res) => {

        //         if (!res.leadConsumers[0]) {
        //             createToast('Der Finanzierungsrechner ist momentan nicht verfügbar.', 'error');
        //             return;
        //         }

        //         setData({ loanData: fields, campaign: res.leadConsumers[0] });
        //     }).catch((e) => {
        //         createToast('Der Finanzierungsrechner ist für diese Postleitzahl nicht verfügbar.', 'error');
        //         console.error(e);
        //     }).finally(() => {
        //         setIsLoading(false);
        //     });
        // }

        // const constLeaglTextCompany = legalTextHomecloud.replace('{{companyAgb}}', `${data?.campaign?.companyName} AGB`);
        // // additionalMonthlyIncomeInEuro has no api field yet: add to monthlyNetIncomeInEuro
        // const monthlyNetIncomeInEuro = Number(fields.monthlyNetIncomeInEuro || 0) + Number(fields.additionalMonthlyIncomeInEuro || 0);
        // delete (fields.additionalMonthlyIncomeInEuro);
        // delete (fields.typeOfEmployment);
        // delete (fields.postalCode);

        // const leadData: Pick<ILeadData, 'externalHomeId' | 'trackingId' | 'firstPerson' | 'household' | 'legal' | 'type'> = {
        //     type: termsData.email ? "MORTGAGE_LEAD" : "BUYER_LEAD",
        //     externalHomeId: data.home.property_id,
        //     trackingId: Date.now().toString(),
        //     household: {
        //         remainingDebtTotalInEuro: data.loanData.remainingDebt,
        //         equityTotalInEuro: data.loanData.equity,
        //     },
        //     firstPerson: {
        //         ...fields,
        //         monthlyNetIncomeInEuro: monthlyNetIncomeInEuro,
        //     },
        //     legal: {
        //         isHomecloudTermsChecked: termsData.homecloud,
        //         homecloudTermsWording: constLeaglTextCompany,
        //         hasReceivedHomecloudDataPrivacyNotes: termsData.homecloud,
        //         homecloudDataPrivacyNotesWording: constLeaglTextCompany,
        //         hasReceivedPartnerDataPrivacyNotes: termsData.homecloud,
        //         partnerDataPrivacyNotesWording: constLeaglTextCompany,
        //         isRealEstateDataForwardingChecked: termsData.homecloud,
        //         realEstateDataForwardingWording: constLeaglTextCompany,
        //         isMortgageAdvisorDataForwardingChecked: termsData.email,
        //         mortgageAdvisorDataForwardingWording: legalTextEmail,
        //         isMortgageAdvisoryWanted: termsData.email,
        //         isContactByPhoneWanted: false,
        //         contactByPhoneConsentWording: legalTextEmail,
        //         isContactByEmailWanted: termsData.email,
        //         contactByEmailConsentWording: legalTextEmail,
        //         userAuthenticationType: user.isLoggedIn ? "ACCOUNT" as const : 'NONE' as const,
        //         userConsentType: "CHECKBOX" as const
        //     }
        // termsData
        // }

        // delete(leadData.additionalMonthlyIncomeInEuro)

        // setIsLoading(true);
        // setData({ termsData })
        // LeadSmartApi.createLead(leadData).then((res) => {
        //     console.debug(res);
        //     setData({ firstPerson: fields, termsData, leadResponse: res });
        // }).catch((e) => {
        //     console.error(e);
        //     createToast(`Fehler beim Abruf der API: ${e || 'unbekannter Fehler'} ${(e?.responseData?.message || '')}`, 'error');
        // }).finally(() => {
        //     setIsLoading(false);
        // });
        nextStep();
    }

    const handlePrevStep = (ev) => {
        prevStep({ firstPerson: fields });
    }

    const isSubmitButtonEnabled = fields.birthday && fields.employedSince && fields.monthlyNetIncomeInEuro && inputPatterns.test(fields.postalCode, 'postalCode' as const);

    return <div className={cx(styles.firstPersonData, className)}>

        <h1>Infos zu dir</h1>

        <form onSubmit={handleSubmit}>
            <div className={styles.fields}>

                <div className={styles.date} >
                    <TextField
                        label="Geburtsdatum"
                        required
                        name="birthday"
                        inputProps={{
                            min: `${subtractDate(new Date(), 90, 0, -1).toISOString().substring(0, 10)}`,
                            max: `${subtractDate(new Date(), 16, 0, 1).toISOString().substring(0, 10)}`,
                            // sx: { width: '100%' }
                        }}
                        value={fields.birthday || ''}
                        type="date"
                        onChange={handleDateChange}
                        autoComplete="bday"
                    ></TextField>
                    <Tooltip>
                        Das Alter ist sowohl für die maximale Darlehenssumme relevant, als auch für die Geschwindigkeit, mit der das Darlehen getilgt werden sollte.
                    </Tooltip>
                </div>
                <div>
                    <Select 
                        name="typeOfEmployment"
                        fullWidth
                        value={fields.typeOfEmployment || ''}
                        label="Art der Beschäftigung"
                        onChange={handleChange}
                    >
                        <MenuItem value="">Keine Auswahl</MenuItem>

                        {Object.keys(typeOfEmploymentList).map((key) => {
                            return <MenuItem key={key} value={key}>{typeOfEmploymentList[key]}</MenuItem>
                        })}
                    </Select>
                    <Tooltip>
                        Diese Information hilft, ein umfassenderes Bild der finanziellen Situation zu erhalten und die mögliche 
                        Kredithöhe sowie -konditionen besser zu berechnen.
                    </Tooltip>
                </div>
                <div className={styles.date} >
                    <TextField
                        label="Beschäftigt seit"
                        required
                        name="employedSince"
                        inputProps={{
                            min: `1950-01-01`,
                            max: `${subtractDate(new Date(), 0, 0, 1).toISOString().substring(0, 10)}`,
                            // sx: { width: '100%' }
                        }}
                        value={fields.employedSince || ''}
                        type="date"
                        onChange={handleDateChange}
                    ></TextField>
                    <Tooltip>
                        Diese Information beschreibt das Datum des Tätigkeitsbeginns beim aktuellen Arbeitgeber.
                        Anhand dieser Angabe wird bewertet, wie sicher das Einkommen ist und welche Gehalts- und Lohnsteigerungen zu erwarten sind.
                    </Tooltip>
                </div>
                <div>
                    <NumberField
                        name="monthlyNetIncomeInEuro"
                        required
                        value={fields.monthlyNetIncomeInEuro}
                        label="Monatliches Haushaltsnettoeinkommen"
                        onChange={handleNumberChange}
                        suffix={fields.monthlyNetIncomeInEuro ? ' €' : undefined}
                    />
                    <Tooltip>
                        Das monatliche Nettoeinkommen beschreibt den Betrag der jeden Monat nach Abzug von Steuern und Sozialabgaben als Einnahme aus abhängigen Beschäftigungen
                        zur Zahlung von Miete, Kreditraten, Sparplänen, Versicherungsbeiträgen und Lebenshaltungskosten zur Verfügung steht.<br />
                        <br />
                        Diese Angabe wird benötigt, um die maximale monatliche Kreditbelastung durch ein Immobiliardarlehen abzuschätzen.
                    </Tooltip>
                </div>
                <div>
                    <NumberField
                        name="additionalMonthlyIncome"
                        value={fields.additionalMonthlyIncome}
                        label="Sonstige monatliche Einnahmen"
                        onChange={handleNumberChange}
                        suffix={fields.additionalMonthlyIncome ? ' €' : undefined}
                    />
                    <Tooltip>
                        Unter sonstige monatliche Einnahmen fallen alle regelmäßigen Einkünfte, die nicht als Nettoeinkommen aus einer abhängigen Beschäftigung gezählt werden.
                        Dies kann Einkommen aus Vermietung und Verpachtung, Kapitalerträge, Unterhaltszahlungen, Renten oder andere regelmäßige Zahlungen umfassen.<br />
                        <br />
                        Diese Information hilft, ein umfassenderes Bild der finanziellen Situation zu erhalten und die mögliche Kredithöhe sowie -konditionen besser zu berechnen.
                    </Tooltip>
                </div>
                <div>
                    <TextField
                        label="Postleitzahl"
                        required
                        name="postalCode"
                        pattern={inputPatterns.postalCode}
                        value={fields.postalCode || ''}
                        onChange={handleChange}
                        onBlurError={fields.postalCode && !inputPatterns.test(fields.postalCode, 'postalCode')}
                    ></TextField>
                    <Tooltip>
                        Die Postleitzahl benötigen wir zur Ermittlung passender Finanzierungsberater.
                    </Tooltip>
                </div>
            </div>
            {/* <div className={styles.terms}>
                <Checkbox
                    required
                    value={termsData.homecloud}
                    name="homecloud"
                    onChange={handleTermsChange}
                    label={getLegalText(data.campaign)}
                />
                <Checkbox
                    value={termsData.email}
                    name="email"
                    onChange={handleTermsChange}
                    label={legalTextEmail}
                />
                <p>
                    Die Datenschutzhinweise unseres Finanzierungspartners findest du <a href={data?.affiliate?.privacy_uri} target="_blank" >hier</a> und
                    die Datenschutzhinweise von Wohnglück <a target="_blank" href="/info/datenschutz">hier</a>.
                </p>
            </div> */}
            <div className={styles.annotation}>
                * die gekennzeichneten Felder sind Pflichtfelder
            </div>

            <div className={styles.actions}>
                {Responsive.isSmartphone() 
                    // ? <IconButton color="inherit" onClick={handlePrevStep}><Icon name="navigatePrev" /></IconButton>
                    ? <Button variant="outlined" color="inherit" onClick={handlePrevStep} type="button"><Icon name="navigatePrev" /></Button>
                    : <Button variant="outlined" color="inherit" onClick={handlePrevStep} type="button" startIcon={<Icon name="navigatePrev" />}>zum letzten Schritt zurück</Button>
                }
                <Button type="submit" loading={isLoading} endIcon={<Icon name="navigateNext" />} visualDisabled={!isSubmitButtonEnabled}>Finanzierung checken</Button>
            </div>

        </form>

    </div>
};

export default FirstPersonData;
